import { AutogenLayoutReeferTempQuickInfo } from "./autogen/AutogenLayoutReeferTempQuickInfo";
import { DataDisplayEvent, Image } from "@mcleod/components";
import { ModelRow } from "@mcleod/core";
import { ImageName } from "@mcleod/images";
import { PlanningUtil, TempWarnings } from "../planning/PlanningUtil";

export class ReeferTempQuickInfo extends AutogenLayoutReeferTempQuickInfo {

    private sourceOrdersOnDisplay(event: DataDisplayEvent) {
        const data = event.rowData;
        if (!data) { return ;}

        const fauxData = new ModelRow(null, false, {
            max_temp: data.get("temperature_max", Infinity),
            min_temp: data.get("temperature_min", Infinity),
            return_temp: data.get("return_temp", Infinity),
            setpoint_temp: data.get("setpoint_temp", Infinity),
            com_setpoint_temp: data.get("com_setpnt_temp", Infinity),
            return_var: data.get("return_temp_var", 0),
            setpoint_var: data.get("setpoint_var", 0)
        });

        console.log(fauxData);
        const warnings = PlanningUtil.getTempWarnings(fauxData);
        this.setTempBang(this.imageReturnAirTemp, warnings.return_air);
        this.setTempBang(this.imageSetPointTemp, warnings.setpoint);
    }

    private setTempBang(image: Image, status: TempWarnings) {
        if (status === null || status === TempWarnings.WITHIN) {
            image.visible = false;
            return;
        }
        image.visible = true;

        if (status === TempWarnings.EXCEEDS) {
            image.name = ImageName.triangleWarningSolid;
            image.color = "error";
        } else if (status === TempWarnings.APPROACHING) {
            image.name = ImageName.circleErrorSolid;
            image.color = "warning";
        }
    }
}
